import _get from 'lodash/get'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration, FlowValues } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsV1GetsafeDe } from '@flows/insurance/schemas'

const contents_bike = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('bike_theft_coverage')]:
        BaseSchema_ContentsV1GetsafeDe.shape.bike_theft_coverage,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_bike.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('bike_theft_coverage'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.yes',
            },
            value: true,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.no',
            },
            value: false,
          },
        ],
      },
      {
        type: 'infoBox',
        contentConfiguration: [
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_contentsNxt:steps.contents_bike.infoBox.text',
            },
          },
        ],
      },
    ],
    onSubmit: {
      type: 'simpleHook',

      callback: (flowValues: FlowValues) => {
        if (!_get(flowValues, params.helperFunctions.getParamPath('bike_theft_coverage'))) {
          return {
            formValues: {
              [params.helperFunctions.getParamPath('bike_theft_insured_sum_amount')]: undefined,
              [params.helperFunctions.getHelperPath('insured_sum_confirmation')]: undefined,
              [params.helperFunctions.getHelperPath('insured_sum_show_confirmation')]: undefined,
            },
          }
        }
      },
    },
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('bike_theft_coverage'),
      valueToStepName: {
        true: 'contents_bike_insured_sum',
        false: 'contents_glass',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default contents_bike
